import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected, setMenuSelected_2 } from '@redux/actions/menuAction';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import { getList, exportData } from 'api/facilityDeviceApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import YearSelect from 'components/elements/select-year';
// import FacilitySelect from 'components/elements/select-facility';
import Clearfix from 'components/elements/clearfix';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import { COLOR } from 'config';
import DeviceStageSelect from 'components/elements/select-device-stage';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;
@PageLockHOC(['facilityDevice.view'])
class FacilityDeviceList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.FACILITY_DEVICE.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'Stage.Name',
        text: 'Giai đoạn',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'Name',
        text: 'Tên thiết bị',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'Status',
        text: 'Tình trạng',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'Location',
        text: 'Vị trí',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'TechnicalSpec',
        text: 'Thông số kĩ thuật',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'ProductionDate',
        text: 'Năm sản xuất',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'IsCatalog',
        text: 'Catalog/ data sheet',
        headerAlign: 'center',
        formatter: (cell, row) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'IsCO',
        text: 'CO',
        headerAlign: 'center',
        formatter: (cell, row) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'IsCQ',
        text: 'CQ',
        headerAlign: 'center',
        formatter: (cell, row) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {cell ? (
                <img
                  height={14}
                  alt='check-icon'
                  src='/icons/badge-check.png'
                />
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        dataField: 'LatestMaintenanceDate',
        text: 'Bảo trì bảo dưỡng gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestRepairDate',
        text: 'Sửa chữa gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestCalibrationDate',
        text: 'Hiệu chuẩn gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'LatestVerificationDate',
        text: 'Kiểm định gần nhất',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
    ];

    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_DEVICE.CREATE}?facilityId=${props.facilityId}`,
      'facilityDevice',
      null,
      true,
      true,
      false,
      'Tên cơ sở (dự án)/ Tên thiết bị/ Vị trí/ Tình trạng'
    );

    this.state = {
      ...this.state,
      valueSearch: { facility: this.props.facilityId },
    };
  }

  renderSearchExpandContainer = () => {
    const form = this.props.form;
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <DeviceStageSelect
              label='Giai đoạn'
              fieldForm={{ form: form, name: 'Stage' }}
            />
          </Col>

          <Col xs={4}>
            <YearSelect
              label='Năm sản xuất'
              fieldForm={{ form: form, name: 'ProductionDate' }}
            />
          </Col>
        </Row>
      </div>
    );
  };

  handelSubmitSearch(values) {
    values.stage = _.get(values.Stage, 'value');
    values.productionDate = _.get(values.ProductionDate, 'value');

    super.handelSubmitSearch(values);
  }
}

const mapStateToProps = (state) => ({ menuStore: state.menu });

const mapDispatchToProps = {
  setMenuSelected,
  setMenuSelected_2,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(FacilityDeviceList))
);



// WEBPACK FOOTER //
// ./src/containers/FacilityDeviceContainer/FacilityDeviceList/index.js